<template>
    <b-modal :hide-footer="true" :title="title" centered size="lg" id="modal-videos" :visible="false"
        :no-close-on-backdrop="true" :tabindex="0">
        <div>
            <div class="row">
                <div class="col-lg-12" :class="'video-list'">
                    <div class="dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                            <i class="mdi mdi-play-circle mdi-16px"></i> {{ title_video }}
                        </button>
                        <div class="dropdown-menu" style="max-height: 300px; overflow-y: auto;">
                            <a class="dropdown-item" @click="setVideo(index)" v-for="(video, index) in videos" :key="index">{{video.title}}</a>
                        </div>
                    </div>
                    <br><br>
                    <iframe width="100%" height="315" :src="url_video" :title="title" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<style>
.video-list {
    height: 400px;
    overflow-y: auto;
}
</style>

<script>
export default {
    props: ["item", "visible", "title", "url_video", "title_video"],
    data() {
        return {
            loading: false,
            videos: [
                { url: 'https://www.youtube.com/embed/1joZvCXs4L8?si=1joZvCXs4L8', title: 'Tutorial RMA - CRAS (Parte 1)' },
                { url: 'https://www.youtube.com/embed/dAXdw_ti0Rk?si=dAXdw_ti0Rk', title: 'Tutorial RMA - CRAS (Parte 2)' },
                { url: 'https://www.youtube.com/embed/mcHvtDCN2l4?si=mcHvtDCN2l4', title: 'Tutorial RMA - CRAS (Parte 3)' },
                { url: 'https://www.youtube.com/embed/SP46RXV6EgA?si=SP46RXV6EgA', title: 'Tutorial RMA - CRAS (Parte 4)' },
                { url: 'https://www.youtube.com/embed/OyHjYQdvRb0?si=OyHjYQdvRb0', title: 'Tutorial RMA - CRAS (Parte 5)' },
                { url: 'https://www.youtube.com/embed/Tlf5yvJ-skk?si=Tlf5yvJ-skk', title: 'Tutorial RMA - CRAS (Parte 6)' },
                { url: 'https://www.youtube.com/embed/IVUjciPpxtI?si=IVUjciPpxtI', title: 'Tutorial RMA - CRAS (Parte 7)' },
                { url: 'https://www.youtube.com/embed/AV6BB8qRsVk?si=AV6BB8qRsVk', title: 'Tutorial RMA - CREAS (Parte 1)' },
                { url: 'https://www.youtube.com/embed/dAXdw_ti0Rk?si=dAXdw_ti0Rk', title: 'Tutorial RMA - CREAS (Parte 2)' },
                { url: 'https://www.youtube.com/embed/80NYNY_6guc?si=80NYNY_6guc', title: 'Tutorial RMA - CREAS (Parte 3)' },
                { url: 'https://www.youtube.com/embed/v3w3XIApf8c?si=v3w3XIApf8c', title: 'Tutorial RMA - CREAS (Parte 4)' },
                { url: 'https://www.youtube.com/embed/QVExoKpRsiY?si=QVExoKpRsiY', title: 'Tutorial RMA - CREAS (Parte 5)' },
                { url: 'https://www.youtube.com/embed/zU8fq5spHzE?si=zU8fq5spHzE', title: 'Tutorial RMA - CREAS (Parte 6)' },
                { url: 'https://www.youtube.com/embed/3B7m5o-bgik?si=3B7m5o-bgik', title: 'Tutorial RMA - CREAS (Parte 7)' },
                { url: 'https://www.youtube.com/embed/E0wmwL6P3y0?si=E0wmwL6P3y0', title: 'Tutorial RMA - CREAS (Parte 8)' },
                { url: 'https://www.youtube.com/embed/tCBCRA9AsxQ?si=tCBCRA9AsxQ', title: 'Tutorial RMA - Centro Pop (Parte 1)' },
                { url: 'https://www.youtube.com/embed/SY5tKzAc5WM?si=SY5tKzAc5WM', title: 'Tutorial RMA - Centro Pop (Parte 2)' },
                { url: 'https://www.youtube.com/embed/o6jV2S06Akw?si=o6jV2S06Akw', title: 'Tutorial RMA - Centro Pop (Parte 3)' },
                { url: 'https://www.youtube.com/embed/8Ka7MT0483Q?si=8Ka7MT0483Q', title: 'Tutorial RMA - Centro Pop (Parte 4)' },
                { url: 'https://www.youtube.com/embed/VJhfxe5suks?si=VJhfxe5suks', title: 'Tutorial RMA - Centro Pop (Parte 5)' },
                { url: 'https://www.youtube.com/embed/t8UaSRpePCw?si=t8UaSRpePCw', title: 'Tutorial RMA - Centro Pop (Parte 6)' },
            ]
        };
    },
    mounted() {
        this.url_video = this.videos[0].url;
        this.title_video = this.videos[0].title;
    },
    methods: {
        setVideo(i) {
            this.url_video = this.videos[i].url;
            this.title_video = this.videos[i].title;
        }
    }
};
</script>
   